__turbopack_context__.v({
  "actions": "AddTeamInlineForm-module-scss-module__bE_z0q__actions",
  "body": "AddTeamInlineForm-module-scss-module__bE_z0q__body",
  "closeButton": "AddTeamInlineForm-module-scss-module__bE_z0q__closeButton",
  "container": "AddTeamInlineForm-module-scss-module__bE_z0q__container",
  "description": "AddTeamInlineForm-module-scss-module__bE_z0q__description",
  "header": "AddTeamInlineForm-module-scss-module__bE_z0q__header",
  "separator": "AddTeamInlineForm-module-scss-module__bE_z0q__separator",
  "title": "AddTeamInlineForm-module-scss-module__bE_z0q__title",
});
